import React, { FC } from 'react';
import { makeStyles, Theme, Tooltip, Typography } from '@material-ui/core';
import { ReactComponent as WarningIcon } from 'img/icons/warning.svg';
import classNames from 'classnames';

const useStyles = makeStyles((theme: Theme) => ({
  warningIcon: {
    color: theme.palette.warning.main,
    pointerEvents: 'auto',
    width: 16,
    height: 16,
  },
}));

interface IActionItemWarningIcon {
  tooltipMessage: string;
}

const ActionItemWarningIcon: FC<IActionItemWarningIcon> = ({ tooltipMessage }) => {
  const classes = useStyles();

  return (
    <Tooltip title={<Typography variant="inherit">{tooltipMessage}</Typography>}>
      <WarningIcon className={classNames(classes.warningIcon, 'menu-item-warning')} />
    </Tooltip>
  );
};

export default ActionItemWarningIcon;
